import React, { FunctionComponent, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import classnames from 'classnames';

import { TextButton } from '@components/library/button/index';
import { BFLoader } from '@components/common/loader/main';

if (BFG.environment !== 'js-test') {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
}

const PDFViewer: FunctionComponent<{ fileUrl: string }> = ({ fileUrl }) => {
  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const nextPage = (): void => {
    if (pageNumber === pageCount) {
      setPageNumber(1);
    } else {
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  };

  const prevPage = (): void => {
    if (pageNumber === 1) {
      setPageNumber(pageCount);
    } else {
      setPageNumber((prevPageNumber) => prevPageNumber - 1);
    }
  };

  const pageNavigation = (
    <div
      className={classnames(
        "pdf-viewer-nav",
        { 'pdf-viewer-nav__single-page': pageCount === 1 }
      )}
    >
      {pageCount > 1 && (
        <TextButton
          className="pdf-viewer-nav--button"
          icon="bff-arrow-left"
          onClick={prevPage}
        >
          {bfTranslate('Previous')}
        </TextButton>
      )}
      <span className="pdf-viewer-nav--page-count">
        {`${bfTranslate("Page")} ${pageNumber} ${bfTranslate("of")} ${pageCount}`}
      </span>
      {pageCount > 1 && (
        <TextButton
          className="pdf-viewer-nav--button"
          onClick={nextPage}
        >
          <>{bfTranslate('Next')}<span className="bff-arrow-right" /></>
        </TextButton>
      )}
    </div>
  );

  return (
    <div
      className="pdf-viewer--container"
      data-testid="pdf-viewer--container"
      data-private
    >
      {pageCount > 0 && pageNavigation}
      <Document
        file={fileUrl}
        loading={<BFLoader />}
        onLoadSuccess={({ numPages }): void => setPageCount(numPages)}
      >
        <Page
          key={`page_${pageNumber}`}
          loading={<BFLoader />}
          pageNumber={pageNumber}
          renderAnnotationLayer={false}
          renderTextLayer={false}
        />
      </Document>
    </div>
  );
};

export default PDFViewer;
